export const CHECKPOINT_COLORS = [0xff0000, 0x00ff00, 0x0000ff];
export function createCheckpointState() {
    return {
        currentIndex: 0,
        clockOn: false,
        startTick: 0,
        lastCheckpointTick: 0,
        lastSectorTicks: [0, 0, 0],
        bestSectorTicks: [0, 0, 0],
        bestLapTicks: 0,
    };
}
export function currentCheckpointColor(state) {
    return CHECKPOINT_COLORS[state.currentIndex] ?? CHECKPOINT_COLORS[0];
}
/** Pure reducer: the input state is never mutated. */
export function advanceCheckpoint(state, color, tick) {
    const nextColor = currentCheckpointColor(state);
    if (color !== nextColor) {
        return {
            state: cloneState(state),
            result: { hit: false, lapFinished: false, nextColor },
        };
    }
    const nextState = cloneState(state);
    if (!nextState.clockOn) {
        nextState.clockOn = true;
        nextState.startTick = tick;
        nextState.lastCheckpointTick = tick;
        nextState.currentIndex =
            (nextState.currentIndex + 1) % CHECKPOINT_COLORS.length;
        return {
            state: nextState,
            result: {
                hit: true,
                lapFinished: false,
                nextColor: currentCheckpointColor(nextState),
            },
        };
    }
    const segmentTicks = tick - nextState.lastCheckpointTick;
    const checkpointIndex = nextState.currentIndex;
    const index = ((checkpointIndex + 2) % CHECKPOINT_COLORS.length);
    nextState.lastSectorTicks[index] = segmentTicks;
    const bestSegment = nextState.bestSectorTicks[index] ?? 0;
    if (bestSegment === 0 || segmentTicks < bestSegment)
        nextState.bestSectorTicks[index] = segmentTicks;
    nextState.lastCheckpointTick = tick;
    if (checkpointIndex === 0) {
        const lapTicks = tick - nextState.startTick;
        if (nextState.bestLapTicks === 0 || lapTicks < nextState.bestLapTicks)
            nextState.bestLapTicks = lapTicks;
        nextState.startTick = tick;
        nextState.currentIndex = (checkpointIndex + 1) % CHECKPOINT_COLORS.length;
        return {
            state: nextState,
            result: {
                hit: true,
                lapFinished: true,
                lapTicks,
                bestLapTicks: nextState.bestLapTicks,
                completedSectorIndex: index,
                completedSectorTicks: segmentTicks,
                completedLapSectorTicks: [...nextState.lastSectorTicks],
                nextColor: currentCheckpointColor(nextState),
            },
        };
    }
    nextState.currentIndex = (checkpointIndex + 1) % CHECKPOINT_COLORS.length;
    return {
        state: nextState,
        result: {
            hit: true,
            lapFinished: false,
            completedSectorIndex: index,
            completedSectorTicks: segmentTicks,
            nextColor: currentCheckpointColor(nextState),
        },
    };
}
function cloneState(state) {
    return {
        ...state,
        lastSectorTicks: [...state.lastSectorTicks],
        bestSectorTicks: [...state.bestSectorTicks],
        bestLapTicks: state.bestLapTicks,
    };
}
